import React, { useEffect, useState } from 'react';
import { useThemeMode } from '../../ThemeContext';
import { dataAPI } from '../../helpers/api_service';
import { useNavigate } from 'react-router-dom';

function SubscriptionCard() {
  const { mode } = useThemeMode();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentPlan, setCurrentPlan] = useState(null);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        setLoading(true);
        const response = await dataAPI.getMySubscription();
        if (response && response.status === 'success' && response.data && response.data.activeplan) {
          const activePlan = response.data.activeplan;
          const planDetails = activePlan.subscription_plan || {};
          setCurrentPlan({
            title: (planDetails.title || 'Plan') + ' Plan',
            description: planDetails.description || 'Your current subscription plan',
            price: `$${activePlan.amount_paid}`,
            period: activePlan.billing_cycle === 'monthly' ? '/Monthly' : '/Yearly',
            status: activePlan.subscription_status || 'active'
          });
        } else {
          setCurrentPlan(null);
        }
      } catch (e) {
        setCurrentPlan(null);
      } finally {
        setLoading(false);
      }
    };
    fetchSubscription();
  }, []);

  const badgeStyle = {
    background: '#39d35333',
    color: '#39d353',
    borderRadius: 999,
    padding: '6px 12px',
    fontWeight: 700,
    fontSize: 12,
    border: '1px solid #39d35355',
  };

  const title = loading ? 'Loading...' : (currentPlan ? currentPlan.title : 'Free Plan');
  const desc = loading ? 'Fetching your subscription details' : (currentPlan ? currentPlan.description : 'Enjoy a 7-day free trial or pick the plan that suits you');
  const price = loading ? '' : (currentPlan ? currentPlan.price : '$0');
  const period = loading ? '' : (currentPlan ? currentPlan.period : '/month');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{
            fontSize: 22,
            fontWeight: 800,
            color: mode === 'dark' ? '#FFFFFF' : '#2c3e50',
            marginBottom: 4
          }}>{title}</div>
          <div style={{
            color: mode === 'dark' ? '#B0B0B0' : '#666666',
            fontSize: 14,
          }}>{desc}</div>
        </div>
        <span style={badgeStyle}>Current Plan</span>
      </div>
      <div style={{ marginTop: 16, fontWeight: 800, fontSize: 24, color: mode === 'dark' ? '#FFFFFF' : '#2c3e50' }}>
        {price} {period && <span style={{ fontWeight: 600, fontSize: 16, color: mode === 'dark' ? '#B0B0B0' : '#666666' }}>{` ${period}`}</span>}
      </div>
      <div style={{ flex: 1 }} />
      <button
        onClick={() => navigate('/subscription?view=plans')}
        style={{
          position: 'absolute',
          right: 0,
          bottom: 30,
          background: 'transparent',
          border: 'none',
          color: '#26C3C0',
          padding: 0,
          fontSize: 18,
          fontWeight: 700,
          fontFamily: 'Urbanist, Arial, sans-serif',
          cursor: 'pointer',
          lineHeight: 1.2
        }}
      >
        Upgrade Now
      </button>
    </div>
  );
}

export default SubscriptionCard;


